export class Cart {
  // this.Subtotal = 0.00;
  // this.Discount = 0.00; //this.getDiscountAmt();
  // this.Total = 0.00;
  // this.Coupon = null;
  // this.CartItems = [];
  // this.TaxRates = [];
  // this.TaxTotal = 0.00;

  constructor() {
    this.Subtotal = 0.0;
    this.Discount = 0.0;
    this.Total = 0.0;
    this.Coupon = null;
    this.CartItems = [];
    this.TaxRates = [];
    this.TaxTotal = 0.0;

    // let Subtotal = 0.0;
    // let Discount = 0.0;
    // let Total = 0.0;
    // let Coupon = new Coupon();
    // let CartItems = [];
    // let TaxRates = [];
    // let TaxTotal = 0.0;
  }

  getTaxes() {
    //for each tax rate items in taxrates
    let tempTr = this.TaxRates;
    let tempTaxTotal = 0.0;

    for (var key of Object.keys(tempTr)) {
      let tr = tempTr[key];
      tr.tax_amt = this.Subtotal * (tr.percentage / 100);
      tempTaxTotal += tr.tax_amt;
    }
    this.TaxTotal = tempTaxTotal;

    return tempTr;
  }

  getSubTotal() {
    this.Subtotal = 0;
    let tempSubTotal = 0;
    let getDiscount = 0;

    for (var key of Object.keys(this.CartItems)) {
      // console.log(key + " -> " + p[key])
      let ci = new CartItem();
      ci = this.CartItems[key];
      tempSubTotal += ci.price;

      if (!ci.useAnnualBilling) {
        tempSubTotal = tempSubTotal / 12;
      }

      getDiscount = this.getDiscountAmt(tempSubTotal);

      tempSubTotal = tempSubTotal - Math.abs(getDiscount); //discount is negative amount
    }
    this.Subtotal = tempSubTotal;

    return tempSubTotal;
  }

  getDiscountAmt(subTotal) {
    let discountAmt = 0;

    if (this.Coupon != null) {
      if (this.Coupon.Code != null) {
        if (this.Coupon.CouponType == "Percentage") {
          discountAmt = subTotal * (this.Coupon.DiscAmt / 100);
        } else {
          discountAmt = this.Coupon.DiscAmt;
        }
        discountAmt = -1 * discountAmt;
      }
    }

    this.Discount = discountAmt;

    return discountAmt;
  }

  getTotalAmt() {
    let tempTotal = parseFloat(this.Subtotal) + parseFloat(this.TaxTotal);
    this.Total = tempTotal;
    return tempTotal;
  }

  updateTotals() {
    this.Subtotal = this.getSubTotal();

    this.TaxRates = this.getTaxes();

    this.Total = this.getTotalAmt();
  }
}

export class TaxRate {
  //   tax_type = "";
  //   display_name = "";
  //   percentage = 0;
  //   tax_amt = 0.0;

  constructor() {
    // let tax_type;
    // let display_name;
    // let percentage;
    // let tax_amt;

    this.tax_type = "";
    this.display_name = "";
    this.percentage = 0;
    this.tax_amt = 0.0;
  }

  // this.Id = Id;
  // this.CouponType = CouponType;
  // this.DiscAmt = DiscAmt;
  // this.Code = Code;
  //   }
}

export class Coupon {
  //   Id = 0;
  //   Code = "";
  //   CouponType = "";
  //   DiscAmt = 0;

  constructor() {
    // let Id;
    // let Code;
    // let CouponType;
    // let DiscAmt;
    this.Id = 0;
    this.Code = "";
    this.CouponType = "";
    this.DiscAmt = 0;
  }
}

export class CartItem {
  //   product = [];
  //   useAnnualBilling = false;
  //   price = 0;
  //   userPrice = 0; //parseFloat(product.productLms.UserPriceYear)
  //   numUsers = 0; //= parseInt(product.productLms.numUsers)
  //   activeMonthsPerYear = 0; //parseInt(product.productLms.activeMonthsPerYear)
  //   isMonthlyBillingAllowed = false;
  //   annualBillingText = "";
  //   stripeProdId = 0;
  //   stripePriceIdYearly = 0;
  //   stripePriceIdMonthly = 0;
  //   activeMonthList = [
  //     { name: "Jan", monthOrder: 1, value: false },
  //     { name: "Feb", monthOrder: 2, value: false },
  //     { name: "Mar", monthOrder: 3, value: false },
  //     { name: "Apr", monthOrder: 4, value: false },
  //     { name: "May", monthOrder: 5, value: false },
  //     { name: "Jun", monthOrder: 6, value: false },
  //     { name: "Jul", monthOrder: 7, value: false },
  //     { name: "Aug", monthOrder: 8, value: false },
  //     { name: "Sep", monthOrder: 9, value: false },
  //     { name: "Oct", monthOrder: 10, value: false },
  //     { name: "Nov", monthOrder: 11, value: false },
  //     { name: "Dec", monthOrder: 12, value: false },
  //   ];

  constructor() {
    // let product = [];
    // let useAnnualBilling = false;
    // let price = 0;
    // let userPrice = 0; //parseFloat(product.productLms.UserPriceYear)
    // let numUsers = 0; //= parseInt(product.productLms.numUsers)
    // let activeMonthsPerYear = 0; //parseInt(product.productLms.activeMonthsPerYear)
    // let isMonthlyBillingAllowed = false;
    // let annualBillingText = "";
    // let stripeProdId = 0;
    // let stripePriceIdYearly = 0;
    // let stripePriceIdMonthly = 0;
    // let activeMonthList = [
    //     { name: "Jan", monthOrder: 1, value: false },
    //     { name: "Feb", monthOrder: 2, value: false },
    //     { name: "Mar", monthOrder: 3, value: false },
    //     { name: "Apr", monthOrder: 4, value: false },
    //     { name: "May", monthOrder: 5, value: false },
    //     { name: "Jun", monthOrder: 6, value: false },
    //     { name: "Jul", monthOrder: 7, value: false },
    //     { name: "Aug", monthOrder: 8, value: false },
    //     { name: "Sep", monthOrder: 9, value: false },
    //     { name: "Oct", monthOrder: 10, value: false },
    //     { name: "Nov", monthOrder: 11, value: false },
    //     { name: "Dec", monthOrder: 12, value: false },
    // ];
    this.product = [];
    this.useAnnualBilling = false;
    this.price = 0;
    this.userPrice = 0; //parseFloat(product.productLms.UserPriceYear)
    this.numUsers = 0; //= parseInt(product.productLms.numUsers)
    this.activeMonthsPerYear = 0; //parseInt(product.productLms.activeMonthsPerYear)
    this.isMonthlyBillingAllowed = false;
    this.annualBillingText = "";
    this.stripeProdId = 0;
    this.stripePriceIdYearly = 0;
    this.stripePriceIdMonthly = 0;
    this.activeMonthList = [
      { name: "Jan", monthOrder: 1, value: false },
      { name: "Feb", monthOrder: 2, value: false },
      { name: "Mar", monthOrder: 3, value: false },
      { name: "Apr", monthOrder: 4, value: false },
      { name: "May", monthOrder: 5, value: false },
      { name: "Jun", monthOrder: 6, value: false },
      { name: "Jul", monthOrder: 7, value: false },
      { name: "Aug", monthOrder: 8, value: false },
      { name: "Sep", monthOrder: 9, value: false },
      { name: "Oct", monthOrder: 10, value: false },
      { name: "Nov", monthOrder: 11, value: false },
      { name: "Dec", monthOrder: 12, value: false },
      ];
      
  }

  // this.productId = productId;
  // this.isAnnualBilling = isAnnualBilling;
  // this.price = price;
  //   }

  updatePrice() {
    if (this.useAnnualBilling) {
      this.userPrice = parseFloat(this.product.productLms.userPriceYear);
    } else {
      this.userPrice = parseFloat(this.product.productLms.userPriceMonth);
    }

    this.numUsers = parseInt(this.product.productLms.numUsers);

    this.activeMonthsPerYear = parseInt(
      this.product.productLms.activeMonthsPerYear
    );

    let calcPrice = parseFloat(
      this.userPrice * this.numUsers * this.activeMonthsPerYear
    );
    this.price = calcPrice;
  }
}

export class CartUtils {
  constructor() {
    // this.productId = productId;
    // this.isAnnualBilling = isAnnualBilling;
    // this.price = price;
  }

  reviveCartObj() {
    let newCart = new Cart();
    let oldCart = JSON.parse(localStorage.getItem("cart"), new Cart());

    for (var key in oldCart) {
      if (Object.prototype.hasOwnProperty.call(oldCart, key)) {
        newCart[key] = oldCart[key];
      }
      // if (oldCart.hasOwnProperty(key)) {
      //   newCart[key] = oldCart[key];
      // }
    }

    newCart.CartItems = [];
    let cis = oldCart.CartItems;

    cis.forEach((el) => {
      let newCI = new CartItem();
      for (var key in el) {
        if (Object.prototype.hasOwnProperty.call(el, key)) {
          newCI[key] = el[key];
        }

        //   if (el.hasOwnProperty(key)) {
        //     newCI[key] = el[key];
        //   }
      }
      newCart.CartItems.push(newCI);
    });

    return newCart;
  }
}
